<script lang="tsx">
import { defineComponent, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
const [name] = createNamespace('TicketTownResettleStandardDisplay')

export default defineComponent({
  name,
  props: {
    data: {
      type: Object as PropType<Partial<ApiJtProj.ResettleStandardData>>,
      default: () => ({})
    }
  },
  setup(props) {
    return () => (
      <div class='ant-row-form-item'>
        安置总价款
        <b>{props.data.fangPiaoAnZhiXiangZhen} 元/人</b>
      </div>
    )
  }
})
</script>
